import useDefinedContext from "@entrilia/shared/hooks/useDefinedContext";
import InvestorCommunicationContext from "../InvestorCommunicationContext";
import InvestorCommunicationArticleContentForm from "./InvestorCommunicationArticleContentForm";
import InvestorCommunicationVideoContentForm from "./InvestorCommunicationVideoContentForm";

const InvestorCommunicationContentForm = () => {
  const { state } = useDefinedContext(InvestorCommunicationContext, "InvestorCommunicationContext");

  const { typeState } = state;

  switch (typeState.type) {
    case "Article":
      return <InvestorCommunicationArticleContentForm articleState={typeState} />;
    case "Video":
      return <InvestorCommunicationVideoContentForm videoState={typeState} />;
  }
};

export default InvestorCommunicationContentForm;
